import { create } from "zustand";
import { persist, subscribeWithSelector } from "zustand/middleware";

type State = {
  cloneParameter: string | null;
  cloneProfile: string | null;
}

type Actions = {
  setCloneParameter: (cloneParameter: State["cloneParameter"]) => void;
  setCloneProfile: (cloneProfile: State["cloneProfile"]) => void;
}

const initialState: State = {
  cloneParameter: null,
  cloneProfile: null,
}

export const useGenericStore = create<State & Actions>()(
  subscribeWithSelector(
    persist(
      (set, get) => ({
        ...initialState,
        setCloneParameter: (cloneParameter) => set(() => ({ cloneParameter })),
        setCloneProfile: (cloneProfile) => set(() => ({ cloneProfile })),
      }),
      {
        name: process.env.REACT_APP_TOKEN_GENERIC!,
      },
    ),
  ),
);